var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-icon-logo-svgrepo-com 1",
    clipPath: "url(#clip0_20277_210812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3094 8.6497C16.3094 7.99419 16.2562 7.51584 16.1411 7.01978H8.65576V9.97843H13.0495C12.9609 10.7137 12.4826 11.821 11.4195 12.5651L11.4046 12.6641L13.7714 14.4976L13.9353 14.5139C15.4412 13.1232 16.3094 11.0769 16.3094 8.6497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.65583 16.445C10.8084 16.445 12.6155 15.7363 13.9354 14.5139L11.4196 12.565C10.7464 13.0345 9.84282 13.3623 8.65583 13.3623C6.54755 13.3623 4.75818 11.9716 4.12032 10.0493L4.02682 10.0573L1.56587 11.9618L1.53369 12.0513C2.84471 14.6556 5.53766 16.445 8.65583 16.445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.12011 10.0494C3.95181 9.5533 3.8544 9.02176 3.8544 8.47257C3.8544 7.92332 3.95181 7.39184 4.11126 6.89577L4.1068 6.79013L1.61501 4.85498L1.53349 4.89376C0.993151 5.97449 0.683105 7.18811 0.683105 8.47257C0.683105 9.75703 0.993151 10.9706 1.53349 12.0513L4.12011 10.0494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.65583 3.58269C10.1529 3.58269 11.1627 4.22934 11.7385 4.76974L13.9885 2.57285C12.6067 1.2884 10.8084 0.5 8.65583 0.5C5.53766 0.5 2.84471 2.28937 1.53369 4.89371L4.11146 6.89573C4.75818 4.97347 6.54755 3.58269 8.65583 3.58269Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20277_210812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.56650f6c3c5f78f2277b6374214e938c.svg";
export { ForwardRef as ReactComponent };